import { CompanyAPI } from '@api';

const getRoutesFromDriver = (driverId) => CompanyAPI.getRoutesFromDriver({ driverId })
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getRoutesFromDriver };
